export const EXCLUDED_AUDIT_COLLECTIONS = new Set([
  "_cronjobs",
  "twenty_fourSeven_assignment",
  "selected_schedule_assignment",
  "employment_type_assignment",
  "biometric_operations",
  "biometric_users",
  "biometric_commands",
  "biometric_prints",
  "service_record",
  "audit_logs",
  "notifications",
  "payroll",
  "payroll_back_pay",
]);
